import styled, { keyframes } from 'styled-components';

import { hexToRgba } from '~/common/utils/hex-to-rgba';
import { SPACING } from '~/common/constants/spacing';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(173, 255, 2, 0.5);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(173, 255, 2, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(173, 255, 2, 0);
  }
`;

export const CtaButtonWrapper = styled.div`
  button,
  a {
    animation: ${pulse} 2s infinite;
    box-shadow: 0 4px 15px rgba(173, 255, 2, 0.4);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 6px 25px rgba(173, 255, 2, 0.6);
      transform: translateY(-1px);
    }
  }
`;

export const LoggedInWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING._16};
`;

export const LoggedInActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING._8};
`;

export const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  height: 60px;
  padding: 0 ${SPACING._12};
  align-items: center;
  gap: ${SPACING._12};
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 1000;
`;

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Avatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  > img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${SPACING._4};
  justify-content: center;
  align-items: center;
  user-select: none;

  img {
    width: 50px;
    height: 50px;
  }
`;

export const StyWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1120px;
  width: 100%;
`;

export const MobileMenuButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING._8};
`;

export const MobileMenuBackdrop = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  top: 60px;
  background: ${hexToRgba('#000000', 0.5)};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
  transition: opacity 200ms ease;
  z-index: 999;
`;

export const MobileMenuPanel = styled.div<{ $open: boolean }>`
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  padding: ${SPACING._12};
  background-color: ${({ theme }) => theme.neutral950};
  box-shadow: 0 16px 24px rgba(0, 0, 0, 0.45);
  transform: translateY(${({ $open }) => ($open ? '0' : '-12px')});
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  visibility: ${({ $open }) => ($open ? 'visible' : 'hidden')};
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
  transition: transform 200ms ease, opacity 200ms ease,
    visibility 0ms linear ${({ $open }) => ($open ? '0ms' : '200ms')};
  z-index: 1000;
`;

export const MobileMenuContent = styled.div<{ $open: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${SPACING._12};
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};

  > * {
    width: 100%;
    pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
  }

  > button,
  > a {
    width: 100%;
  }
`;

export const NavItemsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING._10};
  position: relative;
`;

export const ActiveNavIndicator = styled.div`
  position: absolute;
  bottom: -4px;
  height: 2px;
  background-color: ${({ theme }) => theme.primary};
  border-radius: 1px;
  transition: left 200ms ease, width 200ms ease, opacity 150ms ease;
`;
